const END_POINT_PATH = {
	AUTHENTICATE: {
		LOGIN: "/customer/authenticate",
		FORGOT_PASSWORD: "",
	},
	ARTICLES: {
		ARTICLES: "/article/searchArticle/",
		ARTICLE: "/article/",
		CREATE: "/article/save",
		UPDATE: "/article/upsert/",
		DELETE: "/article/delete/",
		CATEGORY_TITLE: "/articleCategory/backoffice/filter",
	},
	FAQ: {
		FAQS: "/faq/search",
		CREATE: "/faq/save",
		UPDATE: "/faq/upsert/",
	},
	JOB: {
		JOBS: "/career/searchData",
		UPDATE: "/career/upsertData/",
	},
	CAREER: {
		CAREERS: "/career/hiringSearch/status",
		UPDATE: "/career/upsert/",
		DELETE: "/career/delete/",
		CREATE: "/career/save",
	},
	BROCHURE: {
		SOLUTION_TITLE: "/solutionGroup/list",
		SERVICES: "/solutionCategories/categorySearch/",
		ALL_BROCHURES: "/brochure/listAll/filter/status/",
		BROCHURES: "/brochure/search/",
		UPDATE: "/brochure/upsert/",
		DELETE: "brochure/delete/",
		CREATE: "/brochure/save",
	},
	SOLUTION: {
		SOLUTION_TITLE: "/solutionGroup/list",
		SERVICES: "/solutionCategories/categorySearch/",
		ALL_SERVICES: "/solution/listAll/filter/status/",
		SERVICES_CARD: "/solution/list/status/",
		CREATE: "/solution/save",
		UPDATE: "/solution/upsert/",
	},
	ENQUIRY: {
		ENQUIRIES: "/enquiry/search",
		UPDATE: "/enquiry/upsert/",
	},
	CLIENT: {
		CLIENT: "/client/",
		CLIENTS: "/client/search/status",
		CREATE: "/client/save",
		UPDATE: "/client/upsert/",
		CLIENT_PLATFORM: "/dropdown/media-types",
		UPDATE_SORT_NUMBER: "/client/backoffice/update/sortNumber/",
	},
	RESOURCES: {
		ACTIVE_TEMPLATE: "/resource/active/template",
		INFO: "/resource/backoffice/find/customer/template/",
		TEMPLATES: "/resource/list/customer",
		UPDATE: "/resource/upsert",
		UPDATE_ACTIVE_TEMPLATE: "/resource/activate/template/",
	},
	ANNOUNCEMENT: {
		ANNOUNCEMENTS: "/announcement/list/",
		ANNOUNCEMENT: "/announcement/",
		CREATE: "/announcement/save",
		UPDATE: "/announcement/upsert/",
	},
	EMAILS: {
		EMAILS: "/emailResource/find/template/",
		UPDATE: "/emailResource/update/template",
	},
	PARTNERS: {
		PARTNERS: "/partner/backoffice/filter/status",
		CREATE: "/partner/save",
		UPDATE: "/partner/upsert/",
	},
	SOLUTION_GROUP: {
		LIST: "/solutionGroup/list",
		CREATE: "/solutionGroup/save",
		UPDATE: "/solutionGroup/upsert/",
	},
	SOLUTION_CATEGORIES: {
		CATEGORIES: "/solutionCategories/backoffice/filter/status",
		CREATE: "/solutionCategories/save",
		UPDATE: "/solutionCategories/upsert/",
	},
	LOCATION: {
		LOCATIONS: "/branch/backoffice/filter/status",
		LOCATION: "/branch/",
		CREATE: "/branch/save",
		UPDATE: "branch/update/",
	},
	ARTICLE_CATEGORY: {
		CATEGORY: "/articleCategory/backoffice/filter",
		CREATE: "/articleCategory/backoffice/save",
		UPDATE: "/articleCategory/backoffice/upsert/",
	},
};

export default END_POINT_PATH;
